// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

type $OptionalProps = {
  className?: string;
};

type $Props = $OptionalProps & $Translate;

const EmptyTableView = function ({
  className,
  t,
}: $Props) {
  return (
    <div className={className}>
      <hr className={'my-0'} />
      <div className={'text-muted text-center p-3'}>
        {t('The list is empty')}
      </div>
    </div>
  );
};

EmptyTableView.defaultProps = {
  className: undefined,
};

export default EmptyTableView;
